(function () {
  var SINGLES = ['cone-de-henne-marron-classique-pret-a-lemploi','cone-de-henne-golecha-noir','cone-de-henne-golecha-marron-fonce','cone-de-henne-marron-orange'];
  var GIFT_PROP = '_cone_offert';
  var CART_RX = /\/cart\/(add|change|update|clear)/;
  function isGift(it) { return it.properties && it.properties[GIFT_PROP]; }
  function coneCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) { return; }
      var h = it.handle || '';
      if (h.indexOf('lot-de-3') > -1) { n += 3 * it.quantity; }
      else if (SINGLES.indexOf(h) > -1) { n += it.quantity; }
    });
    return n;
  }
  function hasGift(cart) { return (cart.items || []).some(isGift); }
  function ping() { setTimeout(function () { if (window.__coneRefresh) { window.__coneRefresh(); } }, 80); }
  function watchCart() {
    if (window.__coneWatch) { return; }
    window.__coneWatch = true;
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function () {
        var a = arguments[0];
        var u = (typeof a === 'string') ? a : (a && a.url) || '';
        var p = of.apply(this, arguments);
        if (CART_RX.test(u)) { try { p.then(ping, function () {}); } catch (err) {} }
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var oopen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        try { if (CART_RX.test(u || '')) { this.addEventListener('load', ping); } } catch (err) {}
        return oopen.apply(this, arguments);
      };
    }
    ['cart:updated','cart:refresh','cart:build','cart:change','ajaxCart:updated','cart:rerender','product:added','ajaxProduct:added'].forEach(function (ev) { document.addEventListener(ev, ping); });
    window.addEventListener('pageshow', ping);
    window.addEventListener('focus', ping);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { ping(); } });
    setInterval(function () { if (!document.hidden && window.__coneRefresh) { window.__coneRefresh(); } }, 2500);
  }
  function init() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-product-blocks] form[action="/cart/add"]'));
    var gift = forms.filter(function (f) { return f.querySelector('input[name="items[1][id]"]'); });
    if (!gift.length) { return; }
    var block = gift[0].closest('.product-block') || gift[0].parentNode;
    var existing = block.querySelector('[data-cone-msg]');
    if (existing) { existing.remove(); }
    var heads = block.querySelectorAll('p');
    if (heads[0]) { heads[0].textContent = 'Votre cône offert'; }
    if (heads[1]) { heads[1].textContent = 'Pour 3 cônes achetés, le 4e est offert.'; }
    var grid = gift[0].parentNode;
    var msg = document.createElement('p');
    msg.setAttribute('data-cone-msg', '');
    msg.style.cssText = 'font-size:.8em;margin:0 0 12px;text-align:center;';
    if (grid && grid.parentNode) { grid.parentNode.insertBefore(msg, grid); } else { block.appendChild(msg); }
    var busy = false;
    function setState(state, remaining) {
      var locked = state !== 'ready';
      gift.forEach(function (f) {
        var b = f.querySelector('button');
        if (!b) { return; }
        b.disabled = locked;
        b.style.opacity = locked ? '0.4' : '1';
        b.style.cursor = locked ? 'not-allowed' : 'pointer';
      });
      if (state === 'added') {
        msg.textContent = 'Cône offert ajouté au panier';
        msg.style.color = '#2e7d32';
      } else if (state === 'locked') {
        msg.textContent = 'Ajoutez ' + remaining + ' cône' + (remaining > 1 ? 's' : '') + ' au panier pour débloquer votre cône offert';
        msg.style.color = '#777';
      } else {
        msg.textContent = 'Cliquez sur le cône que vous voulez en cadeau';
        msg.style.color = '#777';
      }
    }
    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (hasGift(cart)) { setState('added'); return; }
          var c = coneCount(cart);
          if (c < 3) { setState('locked', 3 - c); } else { setState('ready'); }
        })
        .catch(function () {});
    }
    window.__coneRefresh = refresh;
    gift.forEach(function (f) {
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var b = f.querySelector('button');
        if (busy || (b && b.disabled)) { return; }
        var input = f.querySelector('input[name="items[1][id]"]');
        if (!input) { return; }
        busy = true;
        if (b) { b.disabled = true; }
        var payload = { items: [{ id: Number(input.value), quantity: 1, properties: {} }] };
        payload.items[0].properties[GIFT_PROP] = 'true';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json(); })
          .then(function () {
            busy = false;
            ['cart:refresh', 'cart:build', 'ajaxProduct:added'].forEach(function (e2) { try { document.documentElement.dispatchEvent(new CustomEvent(e2, { bubbles: true })); } catch (e3) {} });
            return refresh();
          })
          .catch(function () { busy = false; if (b) { b.disabled = false; } });
      });
    });
    refresh();
    watchCart();
    document.addEventListener('shopify:section:load', init);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();